import Swiper from "swiper/bundle";
import "swiper/css/bundle";

let swiper = null;
let currentMeta = [];
let infoOffcanvas = null;

function escapeHTML(str) {
  if (str == null) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function attachImageLoader(imgEl) {
  if (!imgEl) return;
  const loader = imgEl
    .closest(".egf-slide-inner")
    ?.querySelector(".egf-loader");
  const hideLoader = () => {
    if (loader) loader.style.display = "none";
  };
  const showLoader = () => {
    if (loader) loader.style.display = "";
  };
  if (imgEl.complete && imgEl.naturalWidth > 0) {
    hideLoader();
  } else {
    showLoader();
  }
  imgEl.addEventListener("load", hideLoader, { once: true });
  imgEl.addEventListener("error", hideLoader, { once: true });
}

function updateActiveSlideLoader() {
  if (!swiper) return;
  const slide = swiper.slides?.[swiper.activeIndex];
  if (!slide) return;
  const img = slide.querySelector("img");
  if (!img) return;
  attachImageLoader(img);
}

function updateInfoUI(idx) {
  const modal = document.getElementById("egfLightbox");
  if (!modal) return;
  const btn = modal.querySelector(".photo-infos");
  const oc = modal.querySelector("#egfLightboxDescription");
  if (!btn || !oc) return;

  const { caption = "", description = "" } = currentMeta[idx] || {};
  const hasContent = !!(
    (caption && caption.trim()) ||
    (description && description.trim())
  );
  btn.toggleAttribute("disabled", !hasContent);

  // Si le bouton est disabled, on le cache, sinon on l'affiche
  if (!hasContent) {
    btn.style.display = "none";
  } else {
    btn.style.display = "";
  }

  const btnAlt = modal.querySelector(".photos-infos");
  if (btnAlt) btnAlt.toggleAttribute("disabled", !hasContent);
  const bodyEl = oc.querySelector(".photo-description-content");
  if (!hasContent) {
    if (bodyEl) bodyEl.innerHTML = "";
    return;
  }
  const safeCaption = escapeHTML(caption);
  const safeDescription = escapeHTML(description).replace(/\r?\n/g, "<br>");
  const content =
    description && description.trim()
      ? (caption
          ? "<h6 class='font-case-custom'>" + safeCaption + "</h6>"
          : "") +
        "<p class='small' style='white-space:pre-line'>" +
        safeDescription +
        "</p>"
      : caption
      ? "<h6 class='font-case-custom'>" + safeCaption + "</h6>"
      : "";
  if (bodyEl) bodyEl.innerHTML = content;
}

function bindInfoButton() {
  const modal = document.getElementById("egfLightbox");
  if (!modal) return;
  const btn = modal.querySelector(".photo-infos");
  const oc = modal.querySelector("#egfLightboxDescription");
  if (!btn || !oc) return;
  if (window.bootstrap && window.bootstrap.Offcanvas) {
    infoOffcanvas =
      infoOffcanvas || new window.bootstrap.Offcanvas(oc, { backdrop: false });
  }
  btn.addEventListener("click", () => {
    const idx = swiper ? swiper.realIndex : 0;
    const meta = currentMeta[idx] || { caption: "", description: "" };
    const bodyEl = oc.querySelector(".photo-description-content");
    const hasContent = !!(
      (meta.caption && meta.caption.trim()) ||
      (meta.description && meta.description.trim())
    );
    if (!hasContent) {
      infoOffcanvas.hide();
      return;
    }
    const safeCaption = escapeHTML(meta.caption || "");
    const safeDescription = escapeHTML(meta.description || "").replace(
      /\r?\n/g,
      "<br>"
    );
    const content =
      meta.description && meta.description.trim()
        ? (meta.caption
            ? "<h6 class='font-case-custom'>" + safeCaption + "</h6>"
            : "") +
          "<p class='small' style='white-space:pre-line'>" +
          safeDescription +
          "</p>"
        : meta.caption
        ? "<h6 class='font-case-custom'>" + safeCaption + "</h6>"
        : "";
    console.debug("[EGF] content (click):", content);
    if (bodyEl) bodyEl.innerHTML = content;
    if (!btn.hasAttribute("disabled") && infoOffcanvas && infoOffcanvas.show) {
      infoOffcanvas.show();
    }
  });
}

function openOverlay(slides, meta, startIndex) {
  const modal = document.getElementById("egfLightbox");
  if (!modal) return;
  currentMeta = Array.isArray(meta) ? meta : [];
  const wrapper = modal.querySelector(".swiper-wrapper");
  wrapper.innerHTML = "";
  slides.forEach((src, i) => {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    const m = currentMeta[i] || { caption: "", description: "" };
    slide.innerHTML =
      `<div class="egf-slide-inner position-relative">` +
      `<div class="egf-loader position-absolute top-50 start-50 translate-middle" style="z-index:5;">` +
      `<div class="spinner-border" style="width:2.5rem;height:2.5rem;color: var(--site-text-color);" role="status">` +
      `<span class="visually-hidden">Chargement...</span>` +
      `</div>` +
      `</div>` +
      `<img src="${src}" loading="eager" data-caption="${(m.caption || "")
        .replaceAll('"', "&quot;")
        .replaceAll("\r", "")
        .replaceAll("\n", "&#10;")}" data-description="${(m.description || "")
        .replaceAll('"', "&quot;")
        .replaceAll("\r", "")
        .replaceAll("\n", "&#10;")}"/></div>`;
    wrapper.appendChild(slide);
    const img = slide.querySelector("img");
    attachImageLoader(img);
  });
  if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  }
  const container = modal.querySelector(".egf-lightbox-swiper");
  swiper = new Swiper(container, {
    initialSlide: Math.max(0, Math.min(startIndex || 0, slides.length - 1)),
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 16,
    keyboard: { enabled: true },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    pagination: { el: ".swiper-pagination", clickable: true },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    zoom: true,
  });
  swiper.on("slideChange", () => {
    updateInfoUI(swiper.realIndex);
    updateActiveSlideLoader();
  });
  // Met à jour le contenu quand la modale/offcanvas s'affichent
  modal.addEventListener("shown.bs.modal", () =>
    updateInfoUI(swiper.realIndex)
  );
  // Initialiser le loader pour le slide actif
  updateActiveSlideLoader();
  const ocEl = modal.querySelector("#egfLightboxDescription");
  if (ocEl)
    ocEl.addEventListener("shown.bs.offcanvas", () =>
      updateInfoUI(swiper.realIndex)
    );
  bindInfoButton();
  updateInfoUI(swiper.realIndex);
}

export function initLightboxSwiper() {
  document.addEventListener("click", (e) => {
    const anchor = e.target.closest('[data-bs-target="#egfLightbox"]');
    if (!anchor) return;
    const list = anchor.closest(".js-justified");
    if (!list) return;
    const imgs = Array.from(list.querySelectorAll("li a img"));
    const slides = imgs.map(
      (im) => im.getAttribute("data-full") || im.getAttribute("src")
    );
    const metas = imgs.map((im) => ({
      caption: im.getAttribute("data-caption") || "",
      description: im.getAttribute("data-description") || "",
    }));
    const index = parseInt(anchor.getAttribute("data-index") || "0", 10);
    setTimeout(() => openOverlay(slides, metas, isNaN(index) ? 0 : index), 80);
  });
}

document.addEventListener("DOMContentLoaded", initLightboxSwiper);

// Open description
